var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"width":_vm.width,"height":_vm.height,"src":'https://ls.robotaisolutions.com:5443/LiveApp/play.html?id=' +
    _vm.fileName +
    '&playOrder=vod',"frameborder":"0","allowfullscreen":""}})}
var staticRenderFns = []

export { render, staticRenderFns }